import { render, staticRenderFns } from "./UserMerchantEdit.vue?vue&type=template&id=754d1ce6"
import script from "./UserMerchantEdit.vue?vue&type=script&lang=js"
export * from "./UserMerchantEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports